import { Account } from '@air/api';
import { Airror, matchesAirror, WORKSPACE_INTEGRATION_SSO_NOT_ENABLED } from '@air/errors';

export const getIsSAMLEnforced = async (email: string) => {
  try {
    const ssoOptions = await Account.getAccountSSOOptionsV2({ email });

    if (isAirrorInstance(ssoOptions)) {
      throw ssoOptions;
    }

    if (!ssoOptions.data?.length) {
      return false;
    }

    return !!ssoOptions.data.find((ssoOption) => !!ssoOption.enforce && !!ssoOption.isMember);
  } catch (error) {
    if (matchesAirror(error, WORKSPACE_INTEGRATION_SSO_NOT_ENABLED)) {
      return false;
    } else {
      throw error;
    }
  }
};

// https://linear.app/air/issue/ENG-135/update-isairrorinstance-to-not-use-any
function isAirrorInstance(result: unknown): result is Airror<any> {
  return result instanceof Airror;
}
